
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 128 130","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M0 1.27h127.749V131H0z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"transform":"translate(0 -1)"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('path',{attrs:{"d":"M127.749 66.137c0 35.824-28.598 64.864-63.875 64.864C28.598 131.001 0 101.961 0 66.137 0 30.313 28.598 1.272 63.874 1.272c35.277 0 63.875 29.041 63.875 64.865","fill":"#FFA306","mask":"url(#b)"}})]),_c('path',{attrs:{"d":"M53.68 94.657c-2.67 1.959-4.835.852-4.835-2.454V38.068c0-3.314 2.16-4.416 4.835-2.453l35.416 25.974c2.671 1.959 2.677 5.13 0 7.094L53.68 94.657z","fill":"#FFF"}})])])
          )
        }
      }
    